import { isTechnologyRequired } from 'domain/shared/career';
import type {
  PositionProfile,
  PositionProfileDto,
  PositionProfileFormValues,
  PositionProfilePayload,
  PositionProfileSalaryRangeDto,
  SalaryRange,
} from '../../types';

type EnrichSalaryRanges = (ranges: PositionProfileSalaryRangeDto[]) => Promise<SalaryRange[]>;
type BuildSalaryRangePayload = (ranges: SalaryRange[]) => Promise<PositionProfileSalaryRangeDto[]>;

export const mapPositionProfile = async (
  profile: PositionProfileDto,
  enrichSalaryRanges: EnrichSalaryRanges,
): Promise<PositionProfile> => ({
  ...profile,
  salaryRanges: await enrichSalaryRanges(profile.salaryRanges ?? []),
});

export const mapPositionProfilePayload = async (
  values: PositionProfileFormValues,
  buildSalaryRangePayload: BuildSalaryRangePayload,
): Promise<PositionProfilePayload> => ({
  specializationId: Number(values.specializationId),
  technologyId: isTechnologyRequired(values.specializationId) ? values.technologyId || null : null,
  competencyLevel: values.competencyLevel,
  name: values.name.trim(),
  description: values.description?.trim() || null,
  salaryRanges: await buildSalaryRangePayload(values.salaryRanges ?? []),
});
